module.exports = __webpack_public_path__ + "static/23-mural2-ec5709d5781986793cc80932d7e7c99c.jpg";